// import React, { useState, useEffect } from "react";
// import CustomDrawer from "../../controls/CustomDrawer";
// import Button from "../../controls/Button";
// import Input from "../../controls/Input";
// import Select from "../../controls/Select";
// import CustomSwitch from "../../controls/CustomSwitch";
// import { toast } from "react-toastify";
// import Importfileconfirmbtn from "../../controls/Importfileconfirmbtn";
// import MultiAutocomplete from "../../controls/MultiAutocomplete";
// import { fetchStore } from "../../../api/storeApi";
// import { handleAddOffer, handleEditOffer } from "../../../api/offerApi";
// import Loading from "../../controls/Loading";
// import { fetchProductGroup } from "../../../api/ProductgroupApi";
// import CreatePage from "../../controls/CreatePage";
// import { useLocation, useNavigate } from "react-router-dom";
// import PageSection from "../../controls/PageSection";
// import { IoTimerOutline } from "react-icons/io5";

// const AddCoupon = ({ //onSave }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const editData = location.state?.data || {};

//   // Initialize all state with editData values
//   const [name, setName] = useState(editData.Name || "");
//   const [description, setDescription] = useState(editData.Description || "");
//   const [priority, setPriority] = useState(editData.Priority || 0);
//   const [validityFrom, setValidityFrom] = useState(editData.ValidityFrom || "");
//   const [validityTo, setValidityTo] = useState(editData.ValidityTo || "");
//   const [couponType, setCouponType] = useState(editData.CouponType || "");
//   const [couponCode, setCouponCode] = useState(editData.CouponCode || "");
//   const [codePrefix, setCodePrefix] = useState(editData.CodePrefix || "");
//   const [noOfCoupons, setNoOfCoupons] = useState(editData.NoOfCoupons || "");
//   const [specificDay, setSpecificDay] = useState(editData.SpecificDay || "No");
//   const [specificTime, setSpecificTime] = useState(editData.SpecificTime || "No");
//   const [offerStartTime, setOfferStartTime] = useState(editData.OfferStartTime || { HH: "00", MM: "00", AMPM: "AM" });
//   const [offerEndTime, setOfferEndTime] = useState(editData.OfferEndTime || { HH: "00", MM: "00", AMPM: "AM" });
//   const [specificStore, setSpecificStore] = useState(editData.SpecificStore || false);
//   const [offerType, setOfferType] = useState(editData.OfferType || "");
//   const [offerTypeId, setOfferTypeID] = useState(editData.OfferTypeID || "");
//   const [spreadDiscount, setSpreadDiscount] = useState(editData.SpreadDiscount || false);
//   const [purchaseGroup, setPurchaseGroup] = useState(editData.PurchaseGroup || "");
//   const [purchaseGroupId, setPurchaseGroupId] = useState(editData.PurchaseGroupID || "");
//   const [purchaseQty, setPurchaseQty] = useState(editData.PurchaseQty || "");
//   const [freeGroup, setFreeGroup] = useState(editData.FreeGroup || "");
//   const [freeGroupID, setFreeGroupID] = useState(editData.FreeGroupID || "");
//   const [freeQty, setFreeQty] = useState(editData.FreeQty || "");
//   const [discountPercentage, setDiscountPercentage] = useState(editData.DiscountPercentage || 0);
//   const [discount, setDiscount] = useState(editData.Discount || "");
//   const [discountValue, setDiscountValue] = useState(editData.DiscountValue || 0);
//   const [invoiceAmount, setInvoiceAmount] = useState(editData.InvoiceAmount || 0);
//   const [getXFreeDiscountPercentage, setGetXFreeDiscountPercentage] = useState(editData.GetXFreeDiscountPercentage || 0);
//   const [selectedStores, setSelectedStores] = useState([]);
//   const [days, setDays] = useState({
//     Sunday: false,
//     Monday: false,
//     Tuesday: false,
//     Wednesday: false,
//     Thursday: false,
//     Friday: false,
//     Saturday: false
//   });
//   const [storeData, setStoreData] = useState([]);
//   const [purchaseGroupData, setPurchaseGroupData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   //error
//   const [nameError, setNameError] = useState("");
//   const [couponTypeError, setCouponTypeError] = useState("");
//   const [codePrefixError, setCodePrefixError] = useState("");
//   const [couponCodeError, setCouponCodeError] = useState("");
//   const [couponNumberError, setCouponNumberError] = useState("");
//   const [priorityError, setPriorityError] = useState("");
//   const [validityFromError, setValidityFromError] = useState("");
//   const [validityToError, setValidityToError] = useState("");
//   const [specificDaySelectedError, setSpecificDaySelectedError] = useState("");
//   const [specificTimeSelectedError, setSpecificTimeSelectedError] = useState("");
//   const [dayError, setDayError] = useState("");
//   const [inTimeError, setInTimeError] = useState("");
//   const [outTimeError, setOutTimeError] = useState("");
//   const [storeSelectionError, setStoreSelectionError] = useState("");
//   const [storeNameError, setStoreNameError] = useState("");
//   const [typeError, setTypeError] = useState("");
//   const [invoiceAmountError, setInvoiceAmountError] = useState("");
//   const [discountInError, setDiscountInError] = useState("");
//   const [valueError, setValueError] = useState("");
//   const [offerGroupingError, setOfferGroupingError] = useState("");
//   const [discountPercentageError, setDiscountPercentageError] = useState("");
//   const [getXFreeDiscountPercentageError, setGetXFreeDiscountPercentageError] = useState("");

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const storeResponse = await fetchStore();
//         setStoreData(storeResponse.stores || []);

//         const groupResponse = await fetchProductGroup();
//         setPurchaseGroupData(groupResponse.ProductGroups || []);

//         // Initialize stores from editData after storeData is loaded
//         if (editData.Stores) {
//           const formattedStores = editData.Stores.map(store => {
//             const fullStoreData = storeResponse.stores.find(s => s.key === store.value || s.key === store);
//             return {
//               label: fullStoreData?.StoreName || store,
//               value: fullStoreData?.key || store
//             };
//           });
//           setSelectedStores(formattedStores);
//         }

//         // Initialize days from editData
//         if (editData.SpecificDays) {
//           const newDays = { ...days };
//           editData.SpecificDays.forEach(day => {
//             newDays[day] = true;
//           });
//           setDays(newDays);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         toast.error("Failed to load data");
//       }
//     };

//     fetchData();
//   }, []);

//   const storeOptions = storeData.map((store) => ({
//     label: store.StoreName,
//     value: store.key
//   }));

//   const handleStoreSelection = (event, newValue) => {
//     setSelectedStores(newValue);
//   };

//   const handleDayToggle = (day) => {
//     setDays(prev => ({
//       ...prev,
//       [day]: !prev[day]
//     }));
//   };

//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   const handleSubmit = async () => {
//     let hasError = false;

//     if (name == "") {
//       setNameError("please provide name");
//       hasError = true;
//     }



//     const specificDays = Object.entries(days)
//       .filter(([_, value]) => value)
//       .map(([key]) => key);

//     const payload = {
//       Name: name,
//       Description: description,
//       Priority: Number(priority),
//       ValidityFrom: validityFrom,
//       ValidityTo: validityTo,
//       CouponType: couponType,
//       CouponCode: couponCode,
//       CodePrefix: codePrefix,
//       NoOfCoupons: noOfCoupons,
//       SpecificDay: specificDay,
//       SpecificTime: specificTime,
//       OfferStartTime: offerStartTime,
//       OfferEndTime: offerEndTime,
//       SpecificStore: specificStore,
//       OfferType: offerType,
//       OfferTypeID: offerTypeId,
//       SpreadDiscount: spreadDiscount,
//       PurchaseGroup: purchaseGroup,
//       PurchaseGroupID: purchaseGroupId,
//       PurchaseQty: Number(purchaseQty),
//       FreeGroup: freeGroup,
//       FreeGroupID: freeGroupID,
//       FreeQty: Number(freeQty),
//       DiscountPercentage: Number(discountPercentage),
//       Discount: discount,
//       DiscountValue: Number(discountValue),
//       InvoiceAmount: Number(invoiceAmount),
//       GetXFreeDiscountPercentage: Number(getXFreeDiscountPercentage),
//       IsDeleted: false,
//       Type: "Coupon",
//       SpecificDays: specificDays,
//       Stores: selectedStores,
//       AllStores: !specificStore,
//       ...(editData.key && { key: editData.key }),
//     };

//     setLoading(true);
//     try {
//       const response = editData.key
//         ? await handleEditOffer(editData.key, payload)
//         : await handleAddOffer(payload);

//       if (response?.data.code === "0") {
//         toast.success(editData.key ? "Coupon updated successfully" : "Coupon added successfully");
//         //onSave(payload);
//         navigate(-1);
//       } else {
//         throw new Error(response?.data.message || "Failed to save coupon");
//       }
//     } catch (error) {
//       console.error("Error saving coupon:", error);
//       toast.error(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const couponTypeOptions = [
//     { value: "SC", label: "Single Code" },
//     { value: "AG", label: "Auto-generated" },
//     { value: "CAG", label: "Client Specific (Campaign)" },
//     { value: "UC", label: "Upload Pre-defined Codes" },
//     { value: "CSC", label: "Client Specific Codes" },
//   ];

//   // Add this function to your component
//   const setCurrentTime = () => {
//     const now = new Date();
//     let hours = now.getHours();
//     const minutes = now.getMinutes();
//     const ampm = hours >= 12 ? 'PM' : 'AM';

//     // Convert to 12-hour format
//     hours = hours % 12;
//     hours = hours ? hours : 12; // the hour '0' should be '12'

//     setOfferStartTime({
//       HH: hours.toString().padStart(2, '0'),
//       MM: minutes.toString().padStart(2, '0'),
//       AMPM: ampm
//     });
//   };




//   return (
//     // <CustomDrawer
//     //   setDrawer={setAddCouponComp}
//     //   title={editData?.key ? "Edit Coupons" : "New Coupons"}
//     //   drawerWidth="sm:w-[500px]"
//     //   primaryButtonName={"Save"}
//     //   secondaryButtonName={"Cancel"}
//     //   primaryButtonClick={handleSubmit}
//     //   secondaryButtonClick={() => setAddCouponComp(false)}
//     //   primaryButtonIconType={"save"}
//     //   secondaryButtonIconType={"remove"}
//     // >
//     <CreatePage
//       title={editData?.key ? "Edit Coupons" : "New Coupons"}
//       handleSave={handleSubmit}
//       handleCancel={() => navigate(-1)}
//     >


//       {loading ? <Loading /> :
//         <div className="grid gap-4">
//           <PageSection title={"Basic Details"}>
//             <div className="grid gap-4 mt-6">
//               <div className="grid grid-cols-3 gap-4 ">
//                 <Input
//                   label="Name"
//                   placeholder="Name"
//                   value={name}
//                   onChange={(e) => { setName(e.target.value), setNameError("") }}
//                   errorMessage={nameError}
//                 />

//                 <Input
//                   label="Description"
//                   placeholder="Description"
//                   value={description}
//                   onChange={(e) => setDescription(e.target.value)}
//                 />

//                 <Input
//                   label="Priority"
//                   placeholder="Priority"
//                   type="number"
//                   value={priority}
//                   onChange={(e) => setPriority(e.target.value)}
//                 />
//                 <Select
//                   placeholder="Select Coupon Type"
//                   label="Coupon Type"
//                   options={couponTypeOptions}
//                   value={couponType}
//                   onChange={(e) => { setCouponType(e.target.value), setCouponTypeError("") }}
//                   errorMessage={couponTypeError}
//                 />

//                 {couponType === "SC" && (
//                   <Input
//                     label="Code"
//                     placeholder="Code"
//                     value={couponCode}
//                     onChange={(e) => { setCouponCode(e.target.value), setCouponCodeError("") }}
//                     errorMessage={couponCodeError}
//                   />
//                 )}

//                 {couponType === "AG" && (
//                   <div className="grid grid-cols-2 gap-4">
//                     <div>
//                       <Input
//                         label="Code prefix"
//                         placeholder="code prefix"
//                         value={codePrefix}
//                         onChange={(e) => { setCodePrefix(e.target.value), setCodePrefixError("") }}
//                         errorMessage={codePrefixError}
//                       />
//                     </div>
//                     <div>
//                       <Input
//                         label="No of Coupons"
//                         placeholder="No of Coupons"
//                         value={noOfCoupons}
//                         onChange={(e) => { setNoOfCoupons(e.target.value), setCouponNumberError("") }}
//                         errorMessage={couponNumberError}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 {couponType === "CAG" && (
//                   <Input
//                     label="Code prefix"
//                     placeholder="code prefix"
//                     value={codePrefix}
//                     onChange={(e) => { setCodePrefix(e.target.value), setCodePrefixError("") }}
//                     errorMessage={codePrefixError}
//                   />
//                 )}

//                 {(couponType === "UC" || couponType === "CSC") && (
//                   <div className="w-50 mt-auto" onClick={openModal}>
//                     <Button type="secondary" iconType={"download"}>Upload code</Button>
//                   </div>
//                 )}
//               </div>

//             </div>

//           </PageSection>
//           <PageSection title={"Type"}>
//             <div className="grid gap-4 mt-5">
//               <div className="grid grid-cols-3 gap-4 ">

//                 <Select
//                   fetchAllObject={true}
//                   label="Type"
//                   options={[
//                     { value: "Buy X get Y free", label: "Buy X get Y free" },
//                     { value: "Buy x get y discount percentage", label: "Buy x get y discount percentage" },
//                     { value: "Discount on invoice amount", label: "Discount on invoice amount" },
//                   ]}
//                   value={offerTypeId}
//                   onChange={(e) => {
//                     setOfferType(e.label);
//                     setOfferTypeID(e.value);
//                   }}

//                 />

//                 {offerType === "Buy X get Y free" && (
//                   <>
//                     <CustomSwitch
//                       formlabel="Spread Free Amount Equally To All Offer Products"
//                       checked={spreadDiscount}
//                       onChange={(checked) => setSpreadDiscount(checked)}
//                     />

//                     <Select
//                       fetchAllObject={true}
//                       placeholder="Select Purchase Group"
//                       label="Purchase Group"
//                       options={purchaseGroupData.map((data) => ({
//                         value: data.key,
//                         label: data.Name,
//                       }))}
//                       value={purchaseGroupId}
//                       onChange={(e) => {
//                         setPurchaseGroupId(e.value);
//                         setPurchaseGroup(e.label);
//                       }}
//                     />

//                     <Input
//                       label="Purchase Qty"
//                       type="number"
//                       placeholder="Enter Purchase Qty"
//                       value={purchaseQty}
//                       onChange={(e) => setPurchaseQty(e.target.value)}
//                     />

//                     <Select
//                       fetchAllObject={true}
//                       placeholder="Select free Group"
//                       label="Free Group"
//                       options={purchaseGroupData.map((data) => ({
//                         value: data.key,
//                         label: data.Name,
//                       }))}
//                       value={freeGroupID}
//                       onChange={(e) => {
//                         setFreeGroupID(e.value);
//                         setFreeGroup(e.label);
//                       }}
//                     />

//                     <Input
//                       label="Free Qty"
//                       type="number"
//                       placeholder="Enter Free Qty"
//                       value={freeQty}
//                       onChange={(e) => setFreeQty(e.target.value)}
//                     />
//                   </>
//                 )}

//                 {offerType === "Buy x get y discount percentage" && (
//                   <>
//                     <Select
//                       fetchAllObject={true}
//                       placeholder="Select Purchase Group"
//                       label="Purchase Group"
//                       options={purchaseGroupData.map((data) => ({
//                         value: data.key,
//                         label: data.Name,
//                       }))}
//                       value={purchaseGroupId}
//                       onChange={(e) => {
//                         setPurchaseGroupId(e.value);
//                         setPurchaseGroup(e.label);
//                       }}
//                     />

//                     <Input
//                       label="Purchase Qty"
//                       type="number"
//                       placeholder="Enter Purchase Qty"
//                       value={purchaseQty}
//                       onChange={(e) => setPurchaseQty(e.target.value)}
//                     />

//                     <Select
//                       fetchAllObject={true}
//                       placeholder="Select Discounted Group"
//                       label="Discounted Group"
//                       options={purchaseGroupData.map((data) => ({
//                         value: data.key,
//                         label: data.Name,
//                       }))}
//                       value={freeGroupID}
//                       onChange={(e) => {
//                         setFreeGroupID(e.value);
//                         setFreeGroup(e.label);
//                       }}
//                     />
//                     <Input
//                       label="Discount Percentage"
//                       type="number"
//                       placeholder="Enter Discount Percentage"
//                       value={discountPercentage}
//                       onChange={(e) => setDiscountPercentage(e.target.value)}
//                     />
//                   </>
//                 )}

//                 {offerType === "Discount on invoice amount" && (
//                   <>
//                     <Input
//                       label="Invoice Amount"
//                       type="number"
//                       placeholder="Enter Invoice Amount"
//                       value={invoiceAmount}
//                       onChange={(e) => setInvoiceAmount(e.target.value)}
//                     />

//                     <Select
//                       placeholder="Select Discount Type"
//                       label="Discount Type"
//                       options={[
//                         { label: "Percentage", value: "Percentage" },
//                         { label: "Amount", value: "Amount" },
//                         { label: "Get X free", value: "Get X free" }
//                       ]}
//                       value={discount}
//                       onChange={(e) => setDiscount(e.target.value)}
//                     />

//                     {(discount === "Percentage" || discount === "Amount") && (
//                       <Input
//                         label="Value"
//                         type="number"
//                         placeholder="Enter value"
//                         value={discountValue}
//                         onChange={(e) => setDiscountValue(e.target.value)}
//                       />
//                     )}

//                     {discount === "Get X free" && (
//                       <>
//                         <Select
//                           fetchAllObject={true}
//                           placeholder="Select Free Group"
//                           label="Free Group"
//                           options={purchaseGroupData.map((data) => ({
//                             value: data.key,
//                             label: data.Name,
//                           }))}
//                           value={freeGroupID}
//                           onChange={(e) => {
//                             setFreeGroupID(e.value);
//                             setFreeGroup(e.label);
//                           }}
//                         />

//                         <Input
//                           label="Free Qty"
//                           type="number"
//                           placeholder="Enter Free Qty"
//                           value={freeQty}
//                           onChange={(e) => setFreeQty(e.target.value)}
//                         />
//                         <Input
//                           label="Discount Percentage"
//                           type="number"
//                           placeholder="Enter discount percentage"
//                           value={getXFreeDiscountPercentage}
//                           onChange={(e) => setGetXFreeDiscountPercentage(e.target.value)}
//                         />
//                       </>
//                     )}
//                   </>
//                 )}

//               </div>

//             </div>

//           </PageSection>
//           <PageSection title={"Coupon Validity"}>
//             <div className="grid gap-4 mt-5">
//               <div className="grid grid-cols-3 gap-4 ">
//                 <Input
//                   label="Validity from"
//                   type="date"
//                   value={validityFrom}
//                   onChange={(e) => setValidityFrom(e.target.value)}
//                 />
//                 <Input
//                   label="Validity to"
//                   type="date"
//                   value={validityTo}
//                   onChange={(e) => setValidityTo(e.target.value)}
//                 />
//               </div>
//               <div className="flex gap-4">


//                 <Select
//                   placeholder="Select Day"
//                   label="Specific Day"
//                   options={[
//                     { value: "Yes", label: "Yes" },
//                     { value: "No", label: "No" },
//                   ]}
//                   value={specificDay}
//                   onChange={(e) => setSpecificDay(e.target.value)}
//                 />

//                 {specificDay === "Yes" && (
//                   <div className="flex space-x-5 ">
//                     {Object.keys(days).map((day) => (
//                       <CustomSwitch
//                         key={day}
//                         formlabel={day}
//                         checked={days[day]}
//                         onChange={() => handleDayToggle(day)}
//                       />
//                     ))}
//                   </div>
//                 )}
//               </div>
//               <div className="flex gap-4">
//                 <Select
//                   placeholder="Select Time"
//                   label="Specific Time"
//                   options={[
//                     { value: "Yes", label: "Yes" },
//                     { value: "No", label: "No" },
//                   ]}
//                   value={specificTime}
//                   onChange={(e) => setSpecificTime(e.target.value)}
//                 />

//                 {specificTime === "Yes" && (
//                   <div className="flex items-center gap-4 space-x-10">
//                     <div>
//                       <label >Start time</label>
//                       <div className="flex items-center gap-2">

//                         <div >
//                           <Input
//                             type="number"
//                             min="1"
//                             max="12"
//                             value={offerStartTime.HH}
//                             onChange={(e) => setOfferStartTime({ ...offerStartTime, HH: e.target.value })}
//                           />
//                         </div>

//                         <div >
//                           <Input
//                             type="number"
//                             min="0"
//                             max="59"
//                             value={offerStartTime.MM}
//                             onChange={(e) => setOfferStartTime({ ...offerStartTime, MM: e.target.value })}
//                           />
//                         </div>

//                         <div className="w-[100px]">
//                           <Select
//                             options={[
//                               { value: "AM", label: "AM" },
//                               { value: "PM", label: "PM" }
//                             ]}
//                             value={offerStartTime.AMPM}
//                             onChange={(e) => setOfferStartTime({ ...offerStartTime, AMPM: e.target.value })}
//                           />
//                         </div>
//                         <span
//                           onClick={setCurrentTime}
//                           className="mt-2 flex items-center cursor-pointer text-xl"
//                         >
//                           <IoTimerOutline />
//                         </span>
//                       </div>

//                     </div>


//                     <div className="">


//                       <label >End time</label>
//                       <div className="flex items-center gap-2">
//                         <div >
//                           <Input
//                             type="number"
//                             min="1"
//                             max="12"
//                             value={offerEndTime.HH}
//                             onChange={(e) => setOfferEndTime({ ...offerEndTime, HH: e.target.value })}
//                           />
//                         </div>

//                         <div >
//                           <Input
//                             type="number"
//                             min="0"
//                             max="59"
//                             value={offerEndTime.MM}
//                             onChange={(e) => setOfferEndTime({ ...offerEndTime, MM: e.target.value })}
//                           />
//                         </div>

//                         <div className="w-[100px]">
//                           <Select
//                             options={[
//                               { value: "AM", label: "AM" },
//                               { value: "PM", label: "PM" }
//                             ]}
//                             value={offerEndTime.AMPM}
//                             onChange={(e) => setOfferEndTime({ ...offerEndTime, AMPM: e.target.value })}
//                           />
//                         </div>

//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//               <div className="flex gap-4">

//                 <CustomSwitch
//                   formlabel="Specific Store"
//                   checked={specificStore}
//                   onChange={(checked) => setSpecificStore(checked)}
//                 />

//                 {specificStore &&
//                   <span className="min-w-[500px]">
//                     <MultiAutocomplete
//                       value={selectedStores}
//                       onChange={handleStoreSelection}
//                       label="Select Stores"
//                       placeholder="Choose stores..."
//                       options={storeOptions}
//                     />
//                   </span>}

//               </div>
//             </div>

//           </PageSection>
//           <div className="flex flex-col gap-4">






//             {isModalOpen && <Importfileconfirmbtn onCancel={closeModal} />}








//           </div>
//         </div>}
//     </CreatePage>
//   );
// };

// export default AddCoupon;

import React, { useState, useEffect, useRef } from "react";
import CustomDrawer from "../../controls/CustomDrawer";
import Button from "../../controls/Button";
import Input from "../../controls/Input";
import Select from "../../controls/Select";
import CustomSwitch from "../../controls/CustomSwitch";
import { toast } from "react-toastify";
import Importfileconfirmbtn from "../../controls/Importfileconfirmbtn";
import MultiAutocomplete from "../../controls/MultiAutocomplete";
import { fetchStore } from "../../../api/storeApi";
import { handleAddOffer, handleEditOffer, fetchCoupon, handleAddCoupon } from "../../../api/offerApi";
import Loading from "../../controls/Loading";
import { fetchProductGroup } from "../../../api/ProductgroupApi";
import CreatePage from "../../controls/CreatePage";
import { useLocation, useNavigate } from "react-router-dom";
import PageSection from "../../controls/PageSection";
import { IoTimerOutline } from "react-icons/io5";
import { multipleCouponCodes } from "../../../assets/importFileTemplates"
import { multipleClientCouponCodeTemplate } from "../../../assets/importFileTemplates"
import Icon from "../../../assets/icons/Icon";
import MultipleStoreSelect from "../../controls/MultipleStoreSelect";
import PopupModal from "../../controls/PopupModal";
import Searchbar from "../../controls/Searchbar";
import ExportButton from "../../controls/ExportButton";
import { exportToFile } from "../../controls/DataExporter";
import CustomTable from "../../controls/CustomTable";
import Papa from "papaparse";
import { fetchCustomerByMobileNos } from "../../../api/CustomerApi";
import { isMobileView } from "../../controls/CommonFunctions";

const AddCoupon = ({ onSave }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const editData = location.state?.data || {};
  const [error, setError] = useState(false);
  const topRef = useRef(null);
  // Initialize all state with editData values
  const [importStatus,setImportStatus]=useState([]);
  const [name, setName] = useState(editData.Name || "");
  const [description, setDescription] = useState(editData.Description || "");
  const [priority, setPriority] = useState(editData.Priority || 0);
  const [validityFrom, setValidityFrom] = useState(editData.ValidityFrom || new Date().toISOString().split("T")[0]);
  const [validityTo, setValidityTo] = useState(editData.ValidityTo || new Date(new Date().setDate(new Date().getDate() + 5)).toISOString().split("T")[0]);
  const [couponType, setCouponType] = useState(editData.CouponType || "");
  const [couponCode, setCouponCode] = useState(editData.CouponCode || "");
  const [codePrefix, setCodePrefix] = useState(editData.CodePrefix || "");
  const [noOfCoupons, setNoOfCoupons] = useState(editData.NoOfCoupons || "");
  const [specificDay, setSpecificDay] = useState(editData.SpecificDay=="Yes" ? true :false);
  const [specificTime, setSpecificTime] = useState(editData.SpecificTime =="Yes" ? true :false);
  const [offerStartTime, setOfferStartTime] = useState(editData.OfferStartTime || { HH: "00", MM: "00", AMPM: "AM" });
  const [offerEndTime, setOfferEndTime] = useState(editData.OfferEndTime || { HH: "00", MM: "00", AMPM: "AM" });
  const [specificStore, setSpecificStore] = useState(editData.SpecificStore || false);
  const [offerType, setOfferType] = useState(editData.OfferType || "");
  const [offerTypeId, setOfferTypeID] = useState(editData.OfferTypeID || "");
  const [spreadDiscount, setSpreadDiscount] = useState(editData.SpreadDiscount || false);
  const [purchaseGroup, setPurchaseGroup] = useState(editData.PurchaseGroup || "");
  const [purchaseGroupId, setPurchaseGroupId] = useState(editData.PurchaseGroupID || "");
  const [purchaseQty, setPurchaseQty] = useState(editData.PurchaseQty || "");
  const [freeGroup, setFreeGroup] = useState(editData.FreeGroup || "");
  const [freeGroupID, setFreeGroupID] = useState(editData.FreeGroupID || "");
  const [freeQty, setFreeQty] = useState(editData.FreeQty || "");
  const [discountPercentage, setDiscountPercentage] = useState(editData.DiscountPercentage || 0);
  const [discount, setDiscount] = useState(editData.Discount || "");
  const [discountValue, setDiscountValue] = useState(editData.DiscountValue || 0);
  const [invoiceAmount, setInvoiceAmount] = useState(editData.InvoiceAmount || 0);
  const [getXFreeDiscountPercentage, setGetXFreeDiscountPercentage] = useState(editData.GetXFreeDiscountPercentage || 0);
  const [selectedStores, setSelectedStores] = useState([]);
  const [days, setDays] = useState({
    Sunday: false,
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false
  });

  const [storeData, setStoreData] = useState([]);
  const [purchaseGroupData, setPurchaseGroupData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [fileType, setFileType] = useState("");
  const [fileData, setFileData] = useState([]);
  const [uploadedCodes, setUploadedCodes] = useState([]);
  const [uploadedClientCodes, setUploadedClientCodes] = useState([]);
  const [autoGeneratedCodes, setAutoGeneratedCodes] = useState([]);
  const [customerSpecificCouponCodes, setCustomerSpecificCouponCodes] = useState(editData?.CustomerSpecificCouponCodes || false);
  const [customerSelectionMandatory,setCustomerSelectionMandatory]=useState(editData?.CustomerSelectionMandatory || false);
  const [otpRequired,setOtpRequired]=useState(editData?.OtpRequired || false);
  const [noOfTimesCoupanUsed,setNoOfTimesCouponUsed]=useState(editData?.NoOfTimesCouponUsed || 1);
  const [showStorePopup, setShowStorePopup] = useState(false);
  const [showCouponCodes, setShowCouponCodes] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCustomerCouponCodes, setFilteredCustomerCouponCodes] = useState([]);
  const [filteredCouponCodes, setFilteredCouponCodes] = useState([]);


  // Error states
  const [nameError, setNameError] = useState("");
  const [couponTypeError, setCouponTypeError] = useState("");
  const [codePrefixError, setCodePrefixError] = useState("");
  const [couponCodeError, setCouponCodeError] = useState("");
  const [couponNumberError, setCouponNumberError] = useState("");
  const [priorityError, setPriorityError] = useState("");
  const [validityFromError, setValidityFromError] = useState("");
  const [validityToError, setValidityToError] = useState("");
  const [dayError, setDayError] = useState("");
  const [inTimeError, setInTimeError] = useState("");
  const [outTimeError, setOutTimeError] = useState("");
  const [storeSelectionError, setStoreSelectionError] = useState("");
  const [storeNameError, setStoreNameError] = useState("");
  const [typeError, setTypeError] = useState("");
  const [invoiceAmountError, setInvoiceAmountError] = useState("");
  const [discountInError, setDiscountInError] = useState("");
  const [valueError, setValueError] = useState("");
  const [offerGroupingError, setOfferGroupingError] = useState("");
  const [discountPercentageError, setDiscountPercentageError] = useState("");
  const [getXFreeDiscountPercentageError, setGetXFreeDiscountPercentageError] = useState("");
  const [purchaseGroupError, setPurchaseGroupError] = useState("");
  const [purchaseQtyError, setPurchaseQtyError] = useState("");
  const [freeGroupError, setFreeGroupError] = useState("");
  const [freeQtyError, setFreeQtyError] = useState("");


  const [errorMessage,setErrorMessage]=useState("");
  const [fileLoading,setFileLoading]=useState(false);

  useEffect(() => {

    const fetchCouponDetailsData = async () => {
      try {
        setLoading(true);
        const response = await fetchCoupon(editData?.key);
        console.log("response", editData.key);
        if (response.data.code === "0") {
          const coupons = response.data?.Coupons;
          console.log("editData?.CouponType",editData?.CouponType);
          if (editData?.CouponType === "UC" && !editData?.CustomerSpecificCouponCodes) {

            setUploadedCodes(coupons);
          }
          else if (editData?.CustomerSpecificCouponCodes) {
            setUploadedClientCodes(coupons);
          }
        } else {
          return [];
        }
      } catch (error) {
        toast.error("Failed to fetch coupon details");
        return [];
      }
      finally {
        setLoading(false);
      }
    }
    if (editData.key) {
       
       fetchCouponDetailsData();
          if (editData.SpecificDays) {
          const newDays = { ...days };
          editData.SpecificDays.forEach(day => {
            newDays[day] = true;
          });
          setDays(newDays);
        }

             if (editData.Stores) {
  const formatted = editData.Stores.map((store) => ({
              label: store.label,
              value: store.value
            }));
  setSelectedStores(formatted);
}
    }

  }, [editData?.key]);


  useEffect(() => {

    if (customerSpecificCouponCodes) {
      if (searchQuery.trim() === "") {
        setFilteredCustomerCouponCodes(uploadedClientCodes);
      } else {
        setFilteredCustomerCouponCodes(
          uploadedClientCodes.filter((data) =>
            data?.CouponCode?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            data?.PhoneNo?.includes(searchQuery) 
           || data?.CustomerName?.toLowerCase().includes(searchQuery.toLowerCase())
          )
        );
      }
    }
    else if (couponType == "UC" && !customerSpecificCouponCodes) {
      if (searchQuery.trim() === "") {
        setFilteredCouponCodes(uploadedCodes);
      } else {
        setFilteredCouponCodes(
          uploadedCodes.filter((data) =>
            data?.CouponCode?.toLowerCase().includes(searchQuery.toLowerCase())
          )
        );
      }
    }
  }, [searchQuery, uploadedClientCodes, uploadedCodes]);  // Changed 'stores' to 'uploadedClientCodes' if that's what you meant to depend on

  useEffect(() => {
    if (file && fileType) {
         setErrorMessage("");
      console.log("fileType", fileType);
      if (fileType == ".csv") {
        handleCSV(file);
      } else {
        handleExcel(file);
      }
    }
  }, [file, fileType]);

  const handleCSV = (file) => {
    console.log("parsing csv file:", file);
        Papa.parse(file, {
           header: true, 
            complete: (result) => {
              const data = result.data;
        console.log("data",data);
        if (!Array.isArray(data) || data.length === 0) {
        setErrorMessage("Invalid or empty CSV data");
        return;
      }
        if (couponType === "UC" && !customerSpecificCouponCodes) {
          // For regular coupon codes
          const couponCodeKey = Object.keys(data[0]).find(
            key => key.toLowerCase() === 'couponcode'
          );
         console.log("couponCodeKey",couponCodeKey);
          if (!couponCodeKey) {
            setErrorMessage("CouponCode column not found");
            return;
          }

          const couponCodeData = data
            .map(row => row[couponCodeKey])
            .filter(couponCode => couponCode != null && couponCode.toString().trim() !== '')
            .map(couponCode => ({ CouponCode: couponCode.toString().trim() }));

          setFileData(couponCodeData);
        }
        // Handle different file types (regular coupon codes vs client-specific)
        else if (customerSpecificCouponCodes) {
          // For client-specific coupon codes
          const couponCodeKey = Object.keys(data[0]).find(
            key => key.toLowerCase() === 'couponcode'
          );
          const mobileNoKey = Object.keys(data[0]).find(
            key => key.toLowerCase() === 'mobileno'
          );

          if (!couponCodeKey || !mobileNoKey) {
            setErrorMessage("Required columns (CouponCode, MobileNo) not found");
            return;
          }

          const uniqueCoupons = new Set();
          const clientCouponData = [];
          let duplicateCount = 0;

          data.forEach(row => {
            if (row[couponCodeKey] && row[mobileNoKey]) {
              const couponCode = row[couponCodeKey].toString().trim();
              if (!uniqueCoupons.has(couponCode)) {
                uniqueCoupons.add(couponCode);
                clientCouponData.push({
                  CouponCode: couponCode,
                  PhoneNo: row[mobileNoKey].toString().trim(),
                  CustomerName: row.CustomerName || "",
                  CustomerID: row.CustomerID || ""
                });
              } else {
                duplicateCount++;
              }
            }
          });

          if (duplicateCount > 0) {
            toast.info(`${duplicateCount} duplicate coupon code(s) skipped`);
          }
          console.log("clientCpupondata",clientCouponData);
          setFileData(clientCouponData);
        }
            },
            error: (error) => {
                toast.error("Error parsing CSV file");
                  setErrorMessage("Error parsing CSV file");
                console.error('CSV parsing error:', error);
                 console.log("csv error",error);
                setFile(null);
            }
        });

  };

  const handleExcel = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = window.XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = window.XLSX.utils.sheet_to_json(worksheet);

        if (!Array.isArray(jsonData) || jsonData.length === 0) {
          setErrorMessage("Invalid or empty Excel data");
          return;
        }

        if (couponType === "UC" && !customerSpecificCouponCodes) {
          // For regular coupon codes
          const couponCodeKey = Object.keys(jsonData[0]).find(
            key => key.toLowerCase() === 'couponcode'
          );

          if (!couponCodeKey) {
            setErrorMessage("CouponCode column not found");
            return;
          }

          const couponCodeData = jsonData
            .map(row => row[couponCodeKey])
            .filter(couponCode => couponCode != null && couponCode.toString().trim() !== '')
            .map(couponCode => ({ CouponCode: couponCode.toString().trim() }));

          setFileData(couponCodeData);
        }

        else if (customerSpecificCouponCodes) {
          // For client-specific coupon codes
          const couponCodeKey = Object.keys(jsonData[0]).find(
            key => key.toLowerCase() === 'couponcode'
          );
          const mobileNoKey = Object.keys(jsonData[0]).find(
            key => key.toLowerCase() === 'mobileno'
          );

          if (!couponCodeKey || !mobileNoKey) {
            setErrorMessage("Required columns (CouponCode, MobileNo) not found");
            return;
          }

          const uniqueCoupons = new Set();
          const clientCouponData = [];
          let duplicateCount = 0;

          jsonData.forEach(row => {
            if (row[couponCodeKey] && row[mobileNoKey]) {
              const couponCode = row[couponCodeKey].toString().trim();
              if (!uniqueCoupons.has(couponCode)) {
                uniqueCoupons.add(couponCode);
                clientCouponData.push({
                  CouponCode: couponCode,
                  PhoneNo: row[mobileNoKey].toString().trim(),
                  CustomerName: row.CustomerName || "",
                  CustomerID: row.CustomerID || ""
                });
              } else {
                duplicateCount++;
              }
            }
          });

          if (duplicateCount > 0) {
            setErrorMessage(`${duplicateCount} duplicate coupon code(s) skipped`);
          }

          setFileData(clientCouponData);
        }
      } catch (error) {
        setErrorMessage("Error parsing Excel file");
        console.error('Excel parse error:', error);
      }
    };
    reader.onerror = () => {
      setErrorMessage("Error reading file");
    };
    reader.readAsArrayBuffer(file);
  };

const handleUploadComplete = async () => {
  if (!fileData || fileData.length === 0) {
    toast.error("No valid data found in file");
    return;
  }
  
  setIsModalOpen(false);
  try {
    setLoading(true);


    let importStatus = []; // ✅ Collect all statuses here

    if (couponType === "UC" && !customerSpecificCouponCodes) {
      const validCouponCodes = fileData.filter(
        item => item.CouponCode && item.CouponCode.toString().trim() !== ""
      );

      const uniqueCodes = new Set();
      const uniqueCouponCodes = [];

      validCouponCodes.forEach(item => {
        const code = item.CouponCode.toString().trim();
        if (uniqueCodes.has(code)) {
          importStatus.push({ code, message: "Duplicate coupon code skipped" });
        } else {
          uniqueCodes.add(code);
          uniqueCouponCodes.push({ CouponCode: code });
          importStatus.push({ code, message: "Success" });
        }
      });

      setUploadedCodes(uniqueCouponCodes);
      toast.success(`${uniqueCouponCodes.length} coupon codes uploaded successfully`);
      console.log("uploaded codes", uniqueCouponCodes);
    }

    // ✅ Customer-specific coupon case
    else if (customerSpecificCouponCodes) {
      const uniqueCoupons = new Set();
      const validClientCoupons = [];

      fileData.forEach(item => {
        const couponCode = item.CouponCode?.toString().trim();
        const phoneNo = item.PhoneNo?.toString().trim();

        if (couponCode && phoneNo) {
          if (!uniqueCoupons.has(couponCode)) {
            uniqueCoupons.add(couponCode);
            validClientCoupons.push({
              CouponCode: couponCode,
              PhoneNo: phoneNo,
              CustomerName: item.CustomerName || "",
              CustomerID: item.CustomerID || ""
            });
          } else {
            importStatus.push({
              code: couponCode,
              phoneNo,
              message: "Found duplicate, skipped"
            });
          }
        } else {
          importStatus.push({
            code: couponCode || "N/A",
            phoneNo: phoneNo || "N/A",
            message: "Invalid row skipped"
          });
        }
      });

      if (validClientCoupons.length === 0) {
        importStatus.push({ code: "N/A", message: "No valid customer coupon codes found" });
        setImportStatus(importStatus);
        return;
      }

      // ✅ Collect unique phones
      const allUniquePhones = [...new Set(validClientCoupons.map(c => c.PhoneNo))];

      // ✅ Fetch customers in one call
      const response = await fetchCustomerByMobileNos(allUniquePhones);
      const customerResults = response?.results || [];

      const processedClients = [];
      const processedCoupons = new Set();

      for (const item of validClientCoupons) {
        if (processedCoupons.has(item.CouponCode)) continue;
        processedCoupons.add(item.CouponCode);

        const customerResult = customerResults.find(r => r.mobileNo === item.PhoneNo);

        if (!customerResult || !customerResult.customer) {
          importStatus.push({
            code: item.CouponCode,
            phoneNo: item.PhoneNo,
            message: "Customer not found"
          });
          continue;
        }

        processedClients.push({
          CouponCode: item.CouponCode,
          PhoneNo: item.PhoneNo,
          CustomerID: customerResult.customer.key,
          CustomerName:
            (customerResult?.customer?.FirstName || "") +
              (customerResult?.customer?.LastName || "") || null
        });

        importStatus.push({
          code: item.CouponCode,
          phoneNo: item.PhoneNo,
          message: "Successful"
        });
      }

      setUploadedClientCodes(processedClients);
    }

    // ✅ Save final status
    setImportStatus(importStatus);

  
    setFile(null);
    setFileType("");
    setFileData([]);
  } catch (error) {
    console.error("Error processing coupon codes:", error);
    toast.error("Error processing coupon codes");
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const storeResponse = await fetchStore();
        setStoreData(storeResponse.stores || []);

        const groupResponse = await fetchProductGroup();
        setPurchaseGroupData(groupResponse.ProductGroups || []);

        // Initialize stores from editData after storeData is loaded



        // Initialize days from editData
     
      } catch (error) {
        console.log('error',error);
                 toast.error(error?.response?.message || error?.message || error || "Runtime error occured" );
         
      }
      finally{
        setLoading(false);
      }
    };

    fetchData();
  }, []);




  const handleDayToggle = (day) => {
    setDays(prev => ({
      ...prev,
      [day]: !prev[day]
    }));
    setDayError("");
  };

  const openModal = () => {setIsModalOpen(true),setErrorMessage("")};
  const closeModal = () => {setIsModalOpen(false),setErrorMessage("")};

  const setCurrentTime = () => {
    const now = new Date();
    let hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12;

    setOfferStartTime({
      HH: hours.toString().padStart(2, '0'),
      MM: minutes.toString().padStart(2, '0'),
      AMPM: ampm
    });
    setInTimeError("");
  };

  const validateForm = () => {
    let isValid = true;

    // Reset all errors
    setNameError("");
    setCouponTypeError("");
    setCouponCodeError("");
    setCouponNumberError("");
    setPriorityError("");
    setValidityFromError("");
    setValidityToError("");
    setDayError("");
    setInTimeError("");
    setOutTimeError("");
    setStoreSelectionError("");
    setStoreNameError("");
    setTypeError("");
    setInvoiceAmountError("");
    setDiscountInError("");
    setValueError("");
    setOfferGroupingError("");
    setDiscountPercentageError("");
    setGetXFreeDiscountPercentageError("");
    setPurchaseGroupError("");
    setPurchaseQtyError("");
    setFreeGroupError("");
    setFreeQtyError("");

    // Basic validation
    if (name.trim() === "") {
      setNameError("Please provide coupon name");
      isValid = false;
    }

    if (couponType.trim() === "") {
      setCouponTypeError("Please select Coupon Type");
      isValid = false;
    }

    // Coupon type specific validation
    if (couponType === "SC") {
      if (couponCode.trim() === "") {
        setCouponCodeError("Please enter code");
        isValid = false;
      }
    }

    if (couponType === "AG") {
      if (codePrefix.trim() === "") {
        setCodePrefixError("Please enter Code Prefix");
        isValid = false;
      }
      if (noOfCoupons.trim() === "") {
        setCouponNumberError("Please enter the No. of coupons");
        isValid = false;
      }
      // Note: autoGeneratedCodes validation would need additional state
    }

    if (couponType === "CAG") {
      if (codePrefix.trim() === "") {
        setCodePrefixError("Please enter Code Prefix");
        isValid = false;
      }
    }

    // Validity dates validation
    if (validityFrom.trim() === "") {
      setValidityFromError("Please provide validity start date");
      isValid = false;
    }

    if (validityTo.trim() === "") {
      setValidityToError("Please provide validity end date");
      isValid = false;
    }

    if (validityFrom.trim() !== "" && validityTo.trim() !== "") {
      if (new Date(validityTo) < new Date(validityFrom)) {
        setValidityToError("Validity end date cannot be less than validity start date");
        isValid = false;
      }
    }

    // Specific day validation
    if (specificDay) {
      const isAnyDaySelected = Object.values(days).some(day => day);
      if (!isAnyDaySelected) {
        setDayError("Please select specific day");
        isValid = false;
      }
    }

    // Specific time validation
    if (specificTime) {
      if (offerStartTime.HH === "" || offerStartTime.MM === "" || offerStartTime.AMPM === "") {
        setInTimeError("Please specify Start Time");
        isValid = false;
      }
      if (offerEndTime.HH === "" || offerEndTime.MM === "" || offerEndTime.AMPM === "") {
        setOutTimeError("Please specify End Time");
        isValid = false;
      }
    }

    // Store validation
    if (specificStore && selectedStores.length === 0) {
      setStoreNameError("Please select store");
      isValid = false;
    }

    // Offer type validation
    if (offerTypeId.trim() === "") {
      setTypeError("Please select type");
      isValid = false;
    }

    // Offer type specific validation
    if (offerTypeId === "buyxgety") {
      if (purchaseGroupId.trim() === "") {
        setPurchaseGroupError("Please provide purchase group");
        isValid = false;
      }
      if (purchaseQty === "") {
        setPurchaseQtyError("Please provide quantity");
        isValid = false;
      }
      if (freeGroupID.trim() === "") {
        setFreeGroupError("Please provide free product group");
        isValid = false;
      }
      if (freeQty === "") {
        setFreeQtyError("Please provide quantity");
        isValid = false;
      }
    }

    if (offerTypeId === "Buy x get y discount percentage") {
      if (purchaseGroupId.trim() === "") {
        setPurchaseGroupError("Please provide purchase group");
        isValid = false;
      }
      if (purchaseQty === "") {
        setPurchaseQtyError("Please provide quantity");
        isValid = false;
      }
      if (discountPercentage === 0) {
        setDiscountPercentageError("Please provide discount percentage");
        isValid = false;
      }
    }

    if (offerTypeId === "invoicediscount") {
      if (invoiceAmount === 0) {
        setInvoiceAmountError("Please provide invoice amount");
        isValid = false;
      }
      if (discount.trim() === "") {
        setDiscountInError("Please provide discount type");
        isValid = false;
      }
      if ((discount === "Percentage" || discount === "Amount") && discountValue === 0) {
        setValueError("Please provide discount value");
        isValid = false;
      }
      if (discount === "Get X free") {
        if (freeGroupID.trim() === "") {
          setFreeGroupError("Please provide free group");
          isValid = false;
        }
        if (freeQty === "") {
          setFreeQtyError("Please provide free qty");
          isValid = false;
        }
        if (getXFreeDiscountPercentage === 0) {
          setGetXFreeDiscountPercentageError("Please provide value");
          isValid = false;
        } else if (getXFreeDiscountPercentage > 100) {
          setGetXFreeDiscountPercentageError("Discount cannot be more than 100%");
          isValid = false;
        }
      }
      if (discount === "Percentage" && discountValue >= 100) {
        setValueError("Percentage should be less than 100");
        isValid = false;
      }
    }

    return isValid;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      console.log("not validate");
      setError(true);
      topRef.current?.scrollIntoView({ behavior: 'smooth' });

      return;
    }

    const specificDays = Object.entries(days)
      .filter(([_, value]) => value)
      .map(([key]) => key);

    const basePayload = {
      Name: name,
      Description: description,
      Priority: Number(priority),
      ValidityFrom: validityFrom,
      ValidityTo: validityTo,
      CouponType: couponType,
      CouponCode: couponCode,
      CodePrefix: codePrefix,
      NoOfCoupons: noOfCoupons,
      SpecificDay:specificDay ? "Yes" :"No",
      SpecificTime: specificTime ? "Yes" :"No",
      OfferStartTime: offerStartTime,
      OfferEndTime: offerEndTime,
      SpecificStore: specificStore,
      OfferType: offerType,
      OfferTypeID: offerTypeId,
      CustomerSpecificCouponCodes: customerSpecificCouponCodes,
      SpreadDiscount: spreadDiscount,
      PurchaseGroup: purchaseGroup,
      PurchaseGroupID: purchaseGroupId,
      PurchaseQty: Number(purchaseQty),
      FreeGroup: freeGroup,
      FreeGroupID: freeGroupID,
      FreeQty: Number(freeQty),
      DiscountPercentage: Number(discountPercentage),
      Discount: discount,
      DiscountValue: Number(discountValue),
      InvoiceAmount: Number(invoiceAmount),
      GetXFreeDiscountPercentage: Number(getXFreeDiscountPercentage),
      IsDeleted: false,
      SpecificDays: specificDays,
      Stores: selectedStores,
      AllStores: !specificStore,
      CustomerSelectionMandatory:customerSelectionMandatory,
      OtpRequired:otpRequired,
      NoOfTimesCouponUsed:noOfTimesCoupanUsed,

      ...(editData.key && { key: editData.key }),
      ...(!editData.key && { Type: "Coupon" }),

    };

    setLoading(true);
    try {
      if (editData.key) {
        // Edit existing coupon
        const response = await handleEditOffer(editData.key, basePayload);
        if (response?.data.code === "0") {
          toast.success("Coupon updated successfully");
          //onSave();
          navigate(-1);
        } else {
          throw new Error(response?.data.message || "Failed to update coupon");
        }
      } else {
        // Create new coupons based on type
        console.log(uploadedCodes);


        // Single coupon or client campaign
        const response = await handleAddOffer(basePayload);
        if (response?.data.code === "0") {

          if (customerSpecificCouponCodes && uploadedClientCodes.length > 0) {
            for (const code of uploadedClientCodes) {
              await handleAddCoupon({
                ...basePayload,
                CouponCode: code.CouponCode,
                CustomerID: code.CustomerID || "",
                CustomerName: code.CustomerName || "",
                PhoneNo: code.PhoneNo,
                CouponID: response.data.data.key,
              });
            }
            toast.success(`${uploadedClientCodes.length} client-specific coupons added successfully`);
            //onSave();

          }
          else if ((couponType == "UC" && !customerSpecificCouponCodes) && uploadedCodes.length > 0) {
            for (const code of uploadedCodes) {
              await handleAddCoupon({
                ...basePayload,
                CouponCode: code.CouponCode,
                CouponID: response.data.data.key,
              });
            }
            toast.success(`${uploadedClientCodes.length} client-specific coupons added successfully`);
            //onSave();

          }
          toast.success("Coupon added successfully");
          //onSave();
          navigate(-1);
        } else {
          console.log(response);
          toast.error(response?.data?.message || "Failed to saved coupon !");
        }

      }
    } catch (error) {
      console.error("Error saving coupon:", error);
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const onGenerateClick = () => {
    if (couponType === "AG" && codePrefix !== "") {
      let codes = [];
      for (let couponCode = 0; couponCode < noOfCoupons; couponCode++) {
        let coupon = codePrefix + (couponCode + 1);
        codes.push({ coupon });
      }
      setAutoGeneratedCodes(codes);
    }
  };

  const couponTypeOptions = [
    { value: "SC", label: "Single Code" },
    { value: "UC", label: "Upload Coupon Codes" },
  ];

  const handleExport = async (type) => {
    try {
      let exportColumns = null;
      let data=null;
      if (couponType == "UC" && !customerSpecificCouponCodes) {
        exportColumns = [
          { header: "Code", field: "CouponCode" },
        ]
        data=uploadedCodes;
      }
      else if (customerSpecificCouponCodes){
        exportColumns = [
          { header: "Code", field: "CouponCode" },
          { header: "Mobile No", field: "PhoneNo" },
          { header: "Customer Name", field: "CustomerName" },
        ]
        data=uploadedClientCodes;
      }
      if (data && data.length > 0) {
        await exportToFile({
          data: data,
          columns: exportColumns,
          fileType: type, // 'PDF' or 'CSV'
          title: "CouponCodes",
          landscape: true
        });
      } else {
        toast.warning("No data available to export");
      }
    } catch (error) {
      toast.error(`Export failed: ${error.message}`);
    }
  };


 const handleOnErrorExport = async (type) => {
  try {

    const singleCodeColumns = [
      { header: "Code", field: "code" },
      { header: "Status", field: "message" }
    ];

    const clientSpecificColumns = [
      { header: "Code", field: "code" },
      { header: "Phone No", field: "phoneNo" },
      { header: "Status", field: "message" }
    ];

    const exportColumns =
      type === "clientCoupon"
        ? clientSpecificColumns
        : type === "singleCoupon"
        ? singleCodeColumns
        : null;

  
    await exportToFile({
      data: importStatus,
      columns: exportColumns,
      fileType: "CSV", // you can make this a function param if needed
      title: "Import Status Report",
      landscape: true
    });

    toast.success("Export completed successfully");
  } catch (error) {
    console.error("Export error:", error);
    toast.error(`Export failed: ${error.message || "Unknown error"}`);
  }
};

  return (
    <CreatePage
      title={editData?.key ? "Edit Coupons" : "New Coupons"}
      handleSave={handleSave}
      handleCancel={() => navigate(-1)}
    >
      {loading ? <Loading /> :
        <div className={`flex ${isMobileView() && "flex-col"} gap-4`}>
          <div className="grid gap-4 grid-cols-1 lg:w-[60%]" ref={topRef}>

            {error && (
              <div className="bg-[#FEEDEE] w-full rounded-lg relative"  >
                <div className="m-5">
                  <div className="flex justify-between items-start">
                    <ul className="max-w-[90%] space-y-1 text-[#000000] list-disc list-inside ">
                      {[nameError, couponTypeError, codePrefixError, couponCodeError, couponNumberError, priorityError, validityFromError, validityToError, dayError, inTimeError, outTimeError, storeSelectionError, storeNameError, typeError, invoiceAmountError, discountInError, valueError, offerGroupingError, discountPercentageError, getXFreeDiscountPercentageError, purchaseGroupError, purchaseQtyError, freeGroupError, freeQtyError]
                        .filter(Boolean) // Filters out null/undefined/false values
                        .map((errorMsg, index) => (
                          <li key={index}>{errorMsg}</li>
                        ))}
                    </ul>
                    <span
                      onClick={() => setError(false)} // Clear all errors
                      className="text-red-400 hover:text-red-800 ml-2 w-7 cursor-pointer"
                    >
                      <Icon type="remove" />
                    </span>
                  </div>
                </div>
              </div>
            )}
            <PageSection title={"Basic Information"}>
              <div className="grid gap-4 lg:grid-cols-2 sm:grid-cols-1">

                <Input
                  isMandatory={true}
                  label="Name"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => { setName(e.target.value); setNameError(""); }}
                  errorMessage={nameError}
                />






              </div>
            </PageSection>

  <PageSection title={"Coupon Configuration"}>
              <div className="grid gap-4">
                <div className="grid-cols-2 grid">
                  <Select
                    isMandatory={true}
                    disabled={editData?.key}
                    placeholder="Select Coupon Type"
                    label="Coupon Type"
                    options={couponTypeOptions}
                    value={couponType}
                    onChange={(e) => {
                      setUploadedCodes([]),setUploadedClientCodes([]),
                      setCouponCode("");
                      setCouponType(e.target.value);
                      setCouponTypeError("");
                      setCouponCodeError("");
                      setCodePrefixError("");
                      setCouponNumberError("");
                      setUploadedCodes([]);
                      setUploadedClientCodes([]);
                    }}
                    errorMessage={couponTypeError}
                  />
                </div>

                {couponType === "SC" && (
                  <div className="grid-cols-2 grid">
                    <Input
                      label="Code"
                      placeholder="Code"
                      value={couponCode}
                      onChange={(e) => { setCouponCode(e.target.value); setCouponCodeError(""); }}
                      errorMessage={couponCodeError}
                      tooltipPosition="right"
                      tooltipWidth={"600px"}
                      infoText={"A single coupon code applicable to all or targeted customers.Example: \"Tuesday50\" for 50% off on specific products on Tuesdays. Coupon code should be unique"}
                    />
                  </div>
                )}


                {couponType === "UC" && (
                  <div className="grid-cols-2 ">
                    <CustomSwitch
                      formlabel="Customer specific coupon codes"
                      checked={customerSpecificCouponCodes}
                      onChange={(checked) =>{setUploadedCodes([]),setUploadedClientCodes([]), setCustomerSpecificCouponCodes(checked)}}
                    />
                  </div>

                )}

                {couponType === "UC" && <div >
                  <Button type="secondary" onClick={openModal} iconType={"download"}>{customerSpecificCouponCodes ? "Upload Customer Coupon Codes":"Upload code"}</Button>
                </div>}





                {uploadedClientCodes.length > 0 && customerSpecificCouponCodes && (
                  <div className={`flex ${isMobileView() && "flex-col"} gap-4`} >
                    <Button type="secondary" onClick={() => setUploadedClientCodes([])} >Coupon Codes: {uploadedClientCodes.length} <span className="w-5 ml-3 text-red-500"><Icon type={"delete"} /></span></Button>
                    <Button type="secondary" onClick={() => { setShowCouponCodes(true) }} iconType={"view"}>View Uploaded code</Button>
                        {importStatus.length>0 &&
                            <div
                                 onClick={()=>{handleOnErrorExport("clientCoupon")}}
                                className="flex items-center text-indigo-600 hover:text-indigo-800 font-medium transition-colors text-xs sm:text-sm cursor-pointer"
                              >
                                <span className="w-4 sm:w-5">
                                  <Icon type={"download"} />
                                </span>
                                <span className="ml-1">
                                  Download Import Status
                                </span>
                              </div>
                          //   <ExportButton
                          //   onExport={(value) => { handleOnErrorExport(value) }}
                          // />
                          }
                  </div>

                )}
                {uploadedCodes.length > 0 && !customerSpecificCouponCodes && (
                    <div className={`flex ${isMobileView() && "flex-col"} gap-4`} >
                    <Button type="secondary" onClick={() => setUploadedCodes([])} >Coupon Codes: {uploadedCodes.length} <span className="w-5 ml-3 text-red-500"><Icon type={"delete"} /></span></Button>
                    <Button type="secondary" onClick={() => { setShowCouponCodes(true) }} iconType={"view"}>View Uploaded code</Button>
                       {importStatus.length>0 &&
                            <div
                                 onClick={()=>{handleOnErrorExport("singleCoupon")}}
                                className="flex items-center text-indigo-600 hover:text-indigo-800 font-medium transition-colors text-xs sm:text-sm cursor-pointer"
                              >
                                <span className="w-4 sm:w-5">
                                  <Icon type={"download"} />
                                </span>
                                <span className="ml-1">
                                  Download Import Status
                                </span>
                              </div>
                          //   <ExportButton
                          //   onExport={(value) => { handleOnErrorExport(value) }}
                          // />
                          }
                  </div>

                )}

                  <div className="lg:grid-cols-2  gap-4">
                    <CustomSwitch
                      formlabel="Customer selection mandatory while applying this coupon"
                      checked={customerSelectionMandatory}
                      onChange={(checked) => setCustomerSelectionMandatory(checked)}
                    />
                  </div>

                      {customerSelectionMandatory && <div className="lg:grid-cols-2 gap-4 grid">
                    <CustomSwitch
                      formlabel="OTP verification required"
                      checked={otpRequired}
                      onChange={(checked) => setOtpRequired(checked)}
                    />
                    <div>
                      <Input
                        label="Number of times a coupon can be used per customer."
                        type="number"
                        value={noOfTimesCoupanUsed}
                        onChange={(e) => { setNoOfTimesCouponUsed(e.target.value); }}
                      />
                    </div>
                  </div>}



                <div className="grid lg:grid-cols-2 gap-4">


                  <Select
                    fetchAllObject={true}
                    isMandatory={true}
                    label="Discount rules"
                    options={[
                      { value: "buyxgety", label: "Buy X get Y free" },
    { value: "buyxqtygetydiscountpercentage", label: "Buy X get Y discount percentage" },
    { value: "invoicediscount", label: "Discount on invoice amount" }
                    ]}
                    value={offerTypeId}
                    onChange={(e) => {
                      setOfferType(e.label);
                      setOfferTypeID(e.value);
                      setTypeError("");
                      setPurchaseGroupError("");
                      setPurchaseQtyError("");
                      setFreeGroupError("");
                      setFreeQtyError("");
                      setDiscountPercentageError("");
                      setInvoiceAmountError("");
                      setDiscountInError("");
                      setValueError("");
                      setGetXFreeDiscountPercentageError("");
                    }}
                    errorMessage={typeError}
                  />
                </div>


                <>
                
             
                  {offerTypeId === "buyxgety" && (
                    <div className="grid lg:grid-cols-2 gap-4">


                      <Select
                        fetchAllObject={true}
                        placeholder="Select Purchase Group"
                        label="Purchase Group"
                        options={purchaseGroupData.map((data) => ({
                          value: data.key,
                          label: data.Name,
                        }))}
                        value={purchaseGroupId}
                        onChange={(e) => {
                          setPurchaseGroupId(e.value);
                          setPurchaseGroup(e.label);
                          setPurchaseGroupError("");
                        }}
                        errorMessage={purchaseGroupError}
                      />

                      <Input
                        label="Purchase Qty"
                        type="number"
                        placeholder="Enter Purchase Qty"
                        value={purchaseQty}
                        onChange={(e) => { setPurchaseQty(e.target.value); setPurchaseQtyError(""); }}
                        errorMessage={purchaseQtyError}
                      />

                      <Select
                        fetchAllObject={true}
                        placeholder="Select free Group"
                        label="Free Group"
                        options={purchaseGroupData.map((data) => ({
                          value: data.key,
                          label: data.Name,
                        }))}
                        value={freeGroupID}
                        onChange={(e) => {
                          setFreeGroupID(e.value);
                          setFreeGroup(e.label);
                          setFreeGroupError("");
                        }}
                        errorMessage={freeGroupError}
                      />

                      <Input
                        label="Free Qty"
                        type="number"
                        placeholder="Enter Free Qty"
                        value={freeQty}
                        onChange={(e) => { setFreeQty(e.target.value); setFreeQtyError(""); }}
                        errorMessage={freeQtyError}
                      />
                      <CustomSwitch
                        formlabel="Spread Free Amount Equally To All Offer Products"
                        checked={spreadDiscount}
                        onChange={(checked) => setSpreadDiscount(checked)}
                      />
                    </div>
                  )}

                  {offerType === "Buy x get y discount percentage" && (
                    <div className="grid lg:grid-cols-2 gap-4">
                      <Select
                        fetchAllObject={true}
                        placeholder="Select Purchase Group"
                        label="Purchase Group"
                        options={purchaseGroupData.map((data) => ({
                          value: data.key,
                          label: data.Name,
                        }))}
                        value={purchaseGroupId}
                        onChange={(e) => {
                          setPurchaseGroupId(e.value);
                          setPurchaseGroup(e.label);
                          setPurchaseGroupError("");
                        }}
                        errorMessage={purchaseGroupError}
                      />

                      <Input
                        label="Purchase Qty"
                        type="number"
                        placeholder="Enter Purchase Qty"
                        value={purchaseQty}
                        onChange={(e) => { setPurchaseQty(e.target.value); setPurchaseQtyError(""); }}
                        errorMessage={purchaseQtyError}
                      />

                      <Select
                        fetchAllObject={true}
                        placeholder="Select Discounted Group"
                        label="Discounted Group"
                        options={purchaseGroupData.map((data) => ({
                          value: data.key,
                          label: data.Name,
                        }))}
                        value={freeGroupID}
                        onChange={(e) => {
                          setFreeGroupID(e.value);
                          setFreeGroup(e.label);
                          setFreeGroupError("");
                        }}
                        errorMessage={freeGroupError}
                      />
                      <Input
                        label="Discount Percentage"
                        type="number"
                        placeholder="Enter Discount Percentage"
                        value={discountPercentage}
                        onChange={(e) => {
                          setDiscountPercentage(e.target.value);
                          setDiscountPercentageError("");
                        }}
                        errorMessage={discountPercentageError}
                      />
                    </div>
                  )}

                  {offerTypeId === "invoicediscount" && (
                    <div className="grid lg:grid-cols-2 gap-4">
                      <Input
                        label="Invoice Amount"
                        type="number"
                        placeholder="Enter Invoice Amount"
                        value={invoiceAmount}
                        onChange={(e) => {
                          setInvoiceAmount(e.target.value);
                          setInvoiceAmountError("");
                        }}
                        errorMessage={invoiceAmountError}
                      />

                      <Select
                        placeholder="Select Discount Type"
                        label="Discount Type"
                        options={[
                          { label: "Percentage", value: "Percentage" },
                          { label: "Amount", value: "Amount" },
                          { label: "Get X free", value: "Get X free" }
                        ]}
                        value={discount}
                        onChange={(e) => {
                          setDiscount(e.target.value);
                          setDiscountInError("");
                          setValueError("");
                          setFreeGroupError("");
                          setFreeQtyError("");
                          setGetXFreeDiscountPercentageError("");
                        }}
                        errorMessage={discountInError}
                      />

                      {(discount === "Percentage" || discount === "Amount") && (
                        <Input
                          label="Value"
                          type="number"
                          placeholder="Enter value"
                          value={discountValue}
                          onChange={(e) => {
                            setDiscountValue(e.target.value);
                            setValueError("");
                          }}
                          errorMessage={valueError}
                        />
                      )}

                      {discount === "Get X free" && (
                        <>
                          <Select
                            fetchAllObject={true}
                            placeholder="Select Free Group"
                            label="Free Group"
                            options={purchaseGroupData.map((data) => ({
                              value: data.key,
                              label: data.Name,
                            }))}
                            value={freeGroupID}
                            onChange={(e) => {
                              setFreeGroupID(e.value);
                              setFreeGroup(e.label);
                              setFreeGroupError("");
                            }}
                            errorMessage={freeGroupError}
                          />

                          <Input
                            label="Free Qty"
                            type="number"
                            placeholder="Enter Free Qty"
                            value={freeQty}
                            onChange={(e) => {
                              setFreeQty(e.target.value);
                              setFreeQtyError("");
                            }}
                            errorMessage={freeQtyError}
                          />
                          <Input
                            label="Discount Percentage"
                            type="number"
                            placeholder="Enter discount percentage"
                            value={getXFreeDiscountPercentage}
                            onChange={(e) => {
                              setGetXFreeDiscountPercentage(e.target.value);
                              setGetXFreeDiscountPercentageError("");
                            }}
                            errorMessage={getXFreeDiscountPercentageError}
                          />
                        </>
                      )}
                    </div>
                  )}
                </>

                <div className="grid gap-4">


                  <div className={`flex ${isMobileView() && "flex-col"} gap-4`}>
                    <CustomSwitch
                      formlabel="Discount applicable on specific days"
                      checked={specificDay}
                      onChange={(checked) => { setSpecificDay(checked), setDayError("") }}
                      errorMessage={dayError}
                    />


                    {specificDay && (
                      <div className="grid lg:grid-cols-7 sm:grid-cols-7">
                        {Object.keys(days).map((day) => (
                          <CustomSwitch
                            key={day}
                            formlabel={day}
                            checked={days[day]}
                            onChange={() => handleDayToggle(day)}
                          />
                        ))}
                      </div>
                    )}
                  </div>



                  <div className={`flex ${isMobileView() && "flex-col"} gap-4`}>
                    <CustomSwitch
                      formlabel="Discount applicable on specific time"
                      checked={specificTime}
                      onChange={(checked) => { setSpecificTime(checked), setInTimeError(""), setOutTimeError("") }}
                    />


                    {specificTime && (
                      <div className={`flex ${isMobileView() ? "flex-col" :"items-center"}  gap-4 space-x-10`}>
                        <div>
                          <label>Start time</label>
                          <div className="flex items-center gap-2">
                            <div>
                              <Input
                                type="number"
                                min="1"
                                max="12"
                                value={offerStartTime.HH}
                                onChange={(e) => {
                                  setOfferStartTime({ ...offerStartTime, HH: e.target.value });
                                  setInTimeError("");
                                }}
                              />
                            </div>
                            <div>
                              <Input
                                type="number"
                                min="0"
                                max="59"
                                value={offerStartTime.MM}
                                onChange={(e) => {
                                  setOfferStartTime({ ...offerStartTime, MM: e.target.value });
                                  setInTimeError("");
                                }}
                              />
                            </div>
                            <div className="w-[100px]">
                              <Select
                                options={[
                                  { value: "AM", label: "AM" },
                                  { value: "PM", label: "PM" }
                                ]}
                                value={offerStartTime.AMPM}
                                onChange={(e) => {
                                  setOfferStartTime({ ...offerStartTime, AMPM: e.target.value });
                                  setInTimeError("");
                                }}
                              />
                            </div>
                            <span
                              onClick={setCurrentTime}
                              className="mt-2 flex items-center cursor-pointer text-xl"
                            >
                              <IoTimerOutline />
                            </span>
                          </div>
                          {inTimeError && (
                            <div className="text-red-700 text-sm">{inTimeError}</div>
                          )}
                        </div>

                        <div>
                          <label>End time</label>
                          <div className="flex items-center gap-2">
                            <div>
                              <Input
                                type="number"
                                min="1"
                                max="12"
                                value={offerEndTime.HH}
                                onChange={(e) => {
                                  setOfferEndTime({ ...offerEndTime, HH: e.target.value });
                                  setOutTimeError("");
                                }}
                              />
                            </div>
                            <div>
                              <Input
                                type="number"
                                min="0"
                                max="59"
                                value={offerEndTime.MM}
                                onChange={(e) => {
                                  setOfferEndTime({ ...offerEndTime, MM: e.target.value });
                                  setOutTimeError("");
                                }}
                              />
                            </div>
                            <div className="w-[100px]">
                              <Select
                                options={[
                                  { value: "AM", label: "AM" },
                                  { value: "PM", label: "PM" }
                                ]}
                                value={offerEndTime.AMPM}
                                onChange={(e) => {
                                  setOfferEndTime({ ...offerEndTime, AMPM: e.target.value });
                                  setOutTimeError("");
                                }}
                              />
                            </div>
                          </div>
                          {outTimeError && (
                            <div className="text-red-700 text-sm">{outTimeError}</div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className={`flex ${isMobileView() && "flex-col"} gap-4`}>
                   {storeData.length>1 && <CustomSwitch
                      formlabel="Discount applicable for specific stores"
                      checked={specificStore}
                      onChange={(checked) => {
                        setSpecificStore(checked);
                        setStoreSelectionError("");
                        setStoreNameError("");
                      }}
                    />}

                    {specificStore && (
                      <div className="mt-auto">
                        <Button type="primary" onClick={() => setShowStorePopup(true)} iconType={"store"}>
                          Select Store {selectedStores.length}
                        </Button>
                        {storeNameError && (
                          <div className="text-red-700 text-sm">{storeNameError}</div>
                        )}
                      </div>

                      // <span className="min-w-[500px]">
                      //   <MultiAutocomplete
                      //     value={selectedStores}
                      //     onChange={handleStoreSelection}
                      //     label="Select Stores"
                      //     placeholder="Choose stores..."
                      //     options={storeOptions}
                      //   />

                      // </span>
                    )}
                  </div>
                </div>
              </div>
            </PageSection>

            <PageSection title={"Validity"}>
              <div className="grid gap-4">
                <div className="grid lg:grid-cols-3 gap-4">
                  <Input
                    isMandatory={true}
                    label="Validity from"
                    type="date"
                    value={validityFrom}
                    onChange={(e) => {
                      setValidityFrom(e.target.value);
                      setValidityFromError("");
                      setValidityToError("");
                    }}
                    errorMessage={validityFromError}
                  />
                  <Input
                     isMandatory={true}
                    label="Validity to"
                    type="date"
                    value={validityTo}
                    onChange={(e) => {
                      setValidityTo(e.target.value);
                      setValidityToError("");
                    }}
                    errorMessage={validityToError}
                  />
                </div>


              </div>
            </PageSection>

          </div>
          <div className="lg:w-[40%]">
<PageSection title="Quick Tips">
              <div className="space-y-4 grid gap-4">
                {[
                  {
                    number: 1,
                    title: "Coupon Type: Choose the coupon type based on the distribution method",
                    content: `Use Single Code Coupons for broad promotions shared via marketing channels.<br>
Use Uploaded Codes when distributing unique codes individually, like printed vouchers or targeted campaigns.
This ensures better control over distribution and redemption tracking.`
                  },
                  {
                    number: 2,
                    title: "Discount Rules",
                    content: "Clearly specify discount types (flat, percentage, buy X get Y) and applicable products/categories to avoid misuse."
                  },
                  {
                    number: 3,
                    title:"Validity Periods",
                    content: "Set Validity Periods and Days Always configure start/end dates and optionally restrict to specific days (e.g., weekends) to create urgency and control usage."
                  },
                  {
                    number: 4,
                  title: "Apply Usage Limits",
                    content: " Restrict the number of times a coupon can be used per customer or overall to safeguard your margins."
                  }
                ].map((tip) => (
                  <div key={tip.number} className="bg-gray-50 p-2 rounded-lg">
                    <div className="flex items-start gap-3">
                      <div className="w-6 h-6 rounded-full bg-blue-100 flex-shrink-0 flex items-center justify-center text-blue-600 mt-0.5">
                        <span className="font-semibold">{tip.number}</span>
                      </div>
                      <div>
                        {tip.title && <h4 className="font-semibold mb-1">{tip.title}</h4>}
                        {tip.content.split('\n').map((paragraph, i, arr) => (
                          <div key={i}>
                            {i > 0 && arr.length > 1 && <div className="border-t border-dashed border-gray-300 my-2"></div>}
                            {paragraph.split('<br>').map((line, j) => (
                              <p key={j} className="text-(--tab-gray)">
                                {line}
                                {j < paragraph.split('<br>').length - 1 && <br />}
                              </p>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </PageSection>
          </div>


        </div>
      }
      {isModalOpen && <Importfileconfirmbtn onCancel={closeModal} importtemplatefilepath={customerSpecificCouponCodes ? multipleClientCouponCodeTemplate : multipleCouponCodes} selectedFile={setFile}
        fileType={setFileType}
        handleUploadClick={handleUploadComplete} 
        errorMessage={errorMessage}
        loading={fileLoading}/>}


      {showStorePopup && (
        <MultipleStoreSelect
          setPopup={setShowStorePopup}
          initialSelectedStores={selectedStores}
          onStoreSelectionChange={(selectedStores) => {
            const formatted = selectedStores.map((store) => ({
              label: store.StoreName,
              value: store.key
            }));
            setStoreNameError("");
            setSelectedStores(formatted);
            console.log("Selected stores:", formatted);
          }}
        />
      )}

      {showCouponCodes &&
        <PopupModal
          setPopUp={setShowCouponCodes}
          size="small"
          handleClose={() => setShowCouponCodes(false)}
          title={"Uploaded Coupon Codes"}
        >
          <div className="grid gap-5">
            <div className="flex gap-4">
              <div>
                <Searchbar
                  value={searchQuery}
                  onChange={(e) => { setSearchQuery(e) }}
                  placeholder={customerSpecificCouponCodes ? "Search coupon codes or customer mobile no": "Search coupon codes"}
                  hideFilter={true}
                  hideRefresh={true}
                />
              </div>
              <div className="w-[200px] ml-auto">
                <ExportButton
                  onExport={(value) => { handleExport(value) }}
                />
              </div>
            </div>

           {customerSpecificCouponCodes && <CustomTable
              columns={[
                { headerName: "Code", field: "CouponCode" },
                { headerName: "Mobile No", field: "PhoneNo" },
                { headerName: "Customer Name", field: "CustomerName" }

              ]}
              rows={filteredCustomerCouponCodes}
            />}
              {(couponType=="UC" && !customerSpecificCouponCodes) && <CustomTable
              columns={[
                { headerName: "Code", field: "CouponCode" },
            

              ]}
              rows={filteredCouponCodes}
            />}



          </div>
        </PopupModal>

      }

    </CreatePage>




  );
};

export default AddCoupon;